<template>
  <component
    :is="sectionTag"
    :id="id"
    :aria-labelledby="headerId"
    :class="sectionClass"
    :role="sectionRole"
  >
    <banner-background v-if="banner" />

    <div 
      v-if="hasTitle"
      class="row"
    >
      <h3
        :id="headerId"
        :class="['page-section__header col', headerClass]"
      >
        {{ title }}
        <small v-if="subtitle">{{ subtitle }}</small>
      </h3>
    </div>

    <div class="page-section__content">
      <slot />
    </div>
  </component>
</template>

<script>
import { mapState } from "vuex";
import { isEmpty as _isEmpty } from "lodash";
import STATE from "Constants/campaign/civicactioncenter/state";
import BannerBackground from "CivicActionCenterComponents/shared/BannerBackground.vue";

export default {
  name: "PageSection",
  components: {
    BannerBackground
  },
  props: {
    headerClass: {
      type: [String, Array, Object],
      default: ""
    },
    // HTML id of <section> element + base of computed HTML ids of other
    // elements (e.g. headerId) -- needed for accessibility when this is
    // an actual <section> (i.e. when we have a `title`)
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    banner: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(STATE.SCOPE_CAMPAIGN, {
      campaignDesignColors: STATE.CAMPAIGN_DESIGN_COLORS
    }),
    useBannerTextColor() {
      if (!this.banner) return false;

      const bannerTextColor = this.campaignDesignColors[
        STATE.BANNER_TEXT_COLOR
      ];

      return !_isEmpty(bannerTextColor);
    },
    hasTitle() {
      return !!this.title;
    },
    headerId() {
      return this.hasTitle ? `${this.id}__header` : false;
    },
    sectionClass() {
      return [
        "page-section",
        {
          [`page-section--${this.id}`]: this.id,
          "page-section--secondary": this.secondary,
          "page-section--banner": this.banner,
          "page-section--with-banner-text-color": this.useBannerTextColor
        }
      ];
    },
    // If no `title` prop is passed, this is just a <div> and not a <section>
    sectionRole() {
      return this.hasTitle ? "region" : false;
    },
    sectionTag() {
      return this.hasTitle ? "section" : "div";
    }
  }
};
</script>
